import { fetchData, uploadImage } from "@axios/axios-client";

export const getPerformanceTypesApi = async () => {
  return fetchData({}, `/performance/types`, "GET", true);
};
export const getPerformanceSportsApi = async () => {
  return fetchData({}, `/performance/sports`, "GET", true);
};

export const getPerformanceSportApi = async (sportId: string) => {
  return fetchData({}, `/performance/sports/${sportId}`, "GET", true);
};

export const createPerformanceSportApi = async (
  sportTypeId: string,
  data: any,
) => {
  return fetchData(
    data,
    `performance/types/${sportTypeId}/sports`,
    "POST",
    false,
    true,
  );
};

export const updatePerformanceSportApi = async (
  sportId: string,
  sportTypeId: string,
  data: any,
) => {
  return fetchData(
    data,
    `performance/types/${sportTypeId}/sports/${sportId}`,
    "PATCH",
    false,
    true,
  );
};

export const bulkUpdatePerformanceSportApi = async (data: any) => {
  return fetchData(data, "performance/sports", "PATCH", false, true);
};
export const deletePerformanceSportApi = async (
  sportId: string,
  sportTypeId: string,
) => {
  return fetchData(
    {},
    `performance/types/${sportTypeId}/sports/${sportId}`,
    "DELETE",
    false,
    true,
  );
};

export const createPerformanceSportGalleryApi = async (
  data: any,
  sportId: string,
) => {
  const formData = new FormData();
  data.forEach((file: any) => {
    formData.append("images", file);
  });
  return uploadImage({
    data: formData,
    url: `/performance/sports/${sportId}/gallery`,
    method: "POST",
    contentType: true,
  });
};

export const updatePerformanceSportGalleryApi = async (
  data: any,
  sportId: string,
) => {
  return uploadImage({
    data,
    url: `/performance/sports/${sportId}/gallery`,
    method: "PUT",
    contentType: false,
  });
};

export const deletePerformanceSportGalleryApi = async (
  data: any,
  sportId: string,
) => {
  return uploadImage({
    data: { ids: data },
    url: `/performance/sports/${sportId}/gallery`,
    method: "PATCH",
    contentType: false,
  });
};
